import { ReactNode } from 'react';

import { createCtx } from '@pletly/ui';
import { useConversations } from './useConversations';

const initialState = {};

type ContextType = typeof initialState;

const [useChats, ChatsDataProvider] = createCtx<ContextType>();

const ChatsProvider = ({ children }: { children?: ReactNode }) => {
	useConversations();

	return <ChatsDataProvider value={{}}>{children}</ChatsDataProvider>;
};

export { ChatsProvider, useChats };
